import React, { useState } from "react";
import { useSettlementTypes, useUpdateSettlementType } from "../../api/settlementTypes";
import { StatusTag } from "../../components/StatusTag";
import { PaginationBar } from "../../components/PaginationBar";
import { useToast } from "../../components/ToastProvider";
import { SettlementTypeModal } from "./SettlementTypeModal";
import { EditIconButton } from "../../components/RowIconButton";
import { SettlementType } from "../../types/dtos";

const PAGE_SIZE = 7;

export default function SettlementTypesPage() {
  const [showNew, setShowNew] = useState(false);
  const [editing, setEditing] = useState<SettlementType | null>(null);
  const [page, setPage] = useState(1);
  const { data: allData, isLoading, isError } = useSettlementTypes(true);
  const update = useUpdateSettlementType();
  const toast = useToast();

  // lista pequena (tipos de baixa cadastrados) — busca tudo de uma vez e pagina no cliente, mas
  // ainda mostra a paginação sempre, igual às outras telas de cadastro.
  const total = allData?.length ?? 0;
  const data = allData?.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  async function handleToggleActive(type: SettlementType) {
    try {
      await update.mutateAsync({ id: type.id, input: { active: !type.active } });
      toast(type.active ? "Tipo de baixa desativado." : "Tipo de baixa reativado.");
    } catch {
      toast("Não foi possível atualizar o status.");
    }
  }

  return (
    <div className="d-flex flex-column gap-3">
      <div className="row g-2">
        <div className="col-md-9" />
        <div className="col-md-3">
          <button type="button" className="btn btn-primary w-100" onClick={() => setShowNew(true)}>
            Novo tipo de baixa
          </button>
        </div>
      </div>

      {isLoading && <div className="text-secondary">Carregando…</div>}
      {isError && <div className="text-danger">Não foi possível carregar os tipos de baixa.</div>}

      {data && (
        <div className="nt-table-wrap" style={{ overflowX: "auto" }}>
          <table className="table nt-table-fade table-striped align-middle">
            <thead>
              <tr>
                <th>Descrição</th>
                <th style={{ width: 140 }}>Status</th>
                <th style={{ width: 150 }}></th>
              </tr>
            </thead>
            <tbody>
              {data?.map((t) => (
                <tr key={t.id}>
                  <td style={{ fontFamily: "var(--font-heading)" }}>{t.name}</td>
                  <td>
                    <StatusTag status={t.active ? "ATIVO" : "INATIVO"} />
                  </td>
                  <td className="text-end">
                    <div className="d-flex gap-2 justify-content-end flex-wrap">
                      <EditIconButton onClick={() => setEditing(t)} />
                      <button
                        type="button"
                        className="btn btn-ghost"
                        style={{ fontSize: 12.5 }}
                        disabled={update.isPending}
                        onClick={() => handleToggleActive(t)}
                      >
                        {t.active ? "Desativar" : "Reativar"}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {total === 0 && (
                <tr>
                  <td colSpan={3} className="text-secondary text-center py-4">
                    Nenhum tipo de baixa cadastrado ainda.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {allData && <PaginationBar page={page} pageSize={PAGE_SIZE} total={total} onPageChange={setPage} />}

      <SettlementTypeModal show={showNew} editing={null} onClose={() => setShowNew(false)} />
      <SettlementTypeModal show={!!editing} editing={editing} onClose={() => setEditing(null)} />
    </div>
  );
}
